import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualConsentsPage() {
    return <MarkdownDocPage title="Consents" markdownUrl="/docs/user-manual/pages/consents.md" />;
}

